import React from 'react';
import { UitkRating } from 'uitk-react-rating';
import gaLogger from 'src/utils/ga-logger';
import { getParameterByName, getLink, checkValue, onImageLoad as imageLoad, appendMcicid, addExtraParamToUrl } from 'src/components/common/helper';
import { Typo } from 'src/components/common/ui';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

const onClickGaTracking = (ga) => {
    const { eventCategory, eventAction, eventLabel } = ga;
    gaLogger.logGa(eventCategory, eventAction, eventLabel);
};
  
const PrimaryButton = (
    link: string,
    text: string,
    css = '',
    target = '_blank',
    btntype = 'primary',
    ga: {
      eventCategory: string;
      eventAction: string;
      eventLabel: string;
    },
    mcicdTrackings?:any
  ) => {
    let url = link;
    if(link){
      if (mcicdTrackings && checkValue(mcicdTrackings.templateType)) {
        const { templateType, campaignUrl, mainUrl, referrerId = '' } = mcicdTrackings;
        url = appendMcicid(link, templateType, campaignUrl, mainUrl, referrerId);
      }

      url = addExtraParamToUrl(url);
    }

   
    btntype = btntype === 'No CTA' ? 'nocta' : btntype;
  
    return text !== '' ? (
      <a
        href={url}
        data-url={url}
        className={`${css} ${btntype.toLowerCase()}`}
        target={target}
        onClick={() => onClickGaTracking(ga)}
      >
        {text}
      </a>
    ) : (
      <></>
    );
};

const HotelPartnerCard = (
    imageSrc: string,
    hName: string,
    hlocation: string,
    rating: string,
    details: string,
    price: string,
    strikeOut: string,
    btnUrl: string,
    ga: {
      eventCategory: string;
      eventAction: string;
      eventLabel: string;
    },
    localizationText?: {
      btnText: string;
      pricePerText: string;
      badge: string;
    },
    imageAltText?: string,
    partnerLogos?: {
      logo1: string;
      logo2: string;
    },
    imgCaption?: string,
    expTracking?:
    | {
        templateType: string;
        campaignUrl: string;
        mainUrl: string;
        referrerId: string;
      }
    | undefined
  ) => {
    const htlUrl = btnUrl;
    return (
      <div className='v2-fh-partners-card'>
        <div className='v2-fh-partners-card-details'>
          {checkValue(hName) && <Typo.HTMLText tag="h3" exClass='override-heading-font-family'>{hName}</Typo.HTMLText>}
          {checkValue(rating) && <div className="v2-fh-partners-card-details-rating">
            <UitkRating rating={rating} />
          </div>}
          {checkValue(hlocation) &&<Typo.HTMLText exClass='strong hlocation' tag="p">{hlocation}</Typo.HTMLText>}
          {checkValue(details) &&<Typo.HTMLText tag="p">{details}</Typo.HTMLText>}
          {(checkValue(price) || checkValue(localizationText?.btnText)) && <div className='v2-fh-partners-card-details-action'>
            {checkValue(price) && <div>
              <p className='price'>{price}{checkValue(strikeOut) && <span>{strikeOut}</span>}</p>
              <p className='price-txt'>{localizationText?.pricePerText}</p>
            </div>}
            {PrimaryButton(htlUrl, localizationText?.btnText, 'btn btn-global', '_blank', 'primary', ga,expTracking)}
          </div>}
          {(checkValue(partnerLogos.logo1) || checkValue(partnerLogos.logo2)) && (
            <div className='v2-fh-partners-card-details-logo'>
              {partnerLogos.logo1 && (
                <img
                  src={partnerLogos.logo1}
                  data-placeholder-background="#e5e5e5"
                  alt='partner logo 1'
                  className="lozad"
                />
              )}
              {partnerLogos.logo1 && partnerLogos.logo2 && (
                <div className="v2-fh-partners-card-details-logo-divider"></div>
              )}
              {partnerLogos.logo2 && (
                <img
                  src={partnerLogos.logo2}
                  data-placeholder-background="#e5e5e5"
                  alt='partner logo 2'
                  className="lozad"
                />
              )}
            </div>
          )}
        </div>
        <div className="v2-fh-partners-card-img">
        {checkValue(localizationText?.badge) && <span className="v2-fh-partners-card-img-badge">{localizationText?.badge}</span>}
          <figure>
            <img
              src={imageSrc}
              data-placeholder-background="#e5e5e5"
              alt={imageAltText}
              className="lozad"
              onLoad={(e) => {
                imageLoad(e.currentTarget, imageSrc);
              }}
            />
          </figure>
          {checkValue(imgCaption) && <div className="v2-fh-partners-card-img-caption">
            <UitkIcon
              name="error"
              size={UitkIconSize.EXTRA_SMALL}
            />
            {imgCaption}
          </div>}
        </div>
      </div>
    );
};


export{HotelPartnerCard}